export default __webpack_public_path__ + "static/B0084-20438e1a939d8a24e5267acc733106a3.png";